import apiClient from '../api/api';
import { API_ENDPOINTS } from '../api/api.config';
import authService from './auth.service';

class SessionManagementService {
    async revokeOtherSessions(): Promise<any> {
        try {
            const token = authService.getAccessToken() || localStorage.getItem('auth_token');
            if (!token) {
                throw new Error("No authentication token found");
            }
            const response = await apiClient.post(API_ENDPOINTS.SESSION.REVOKE_OTHERS, { token });
            return response.data;
        } catch (error: any) {
            console.error("Error revoking other sessions:", error);
            throw error;
        }
    }

    async revokeAllSessions(): Promise<any> {
        try {
            const token = authService.getAccessToken() || localStorage.getItem('auth_token');
            if (!token) {
                throw new Error("No authentication token found");
            }
            const response = await apiClient.post(API_ENDPOINTS.SESSION.REVOKE_ALL, { token });
            return response.data;
        } catch (error: any) {
            console.error("Error revoking all sessions:", error);
            throw error;
        }
    }
}

export const sessionManagementService = new SessionManagementService();
export default sessionManagementService;
